import React from "react";
import { useEffect } from "react";
import gtmParts from "react-google-tag-manager";

export const GoogleTagManager = ({ scriptId, gtmId, dataLayerName, additionalEvents }) => {
  const sId = scriptId || "react-google-tag-manager-gtm";

  useEffect(() => {
    const gtmScriptNode = document.getElementById(sId);
    if (gtmScriptNode) {
      // Security: replaced eval() with safe script injection.
      // A new <script> element is created with the GTM content and appended to <head>,
      // which the browser executes without using eval().
      const script = document.createElement("script");
      script.textContent = gtmScriptNode.textContent;
      document.head.appendChild(script);
    }
  }, []);

  const gtm = gtmParts({
    id: gtmId,
    dataLayerName: dataLayerName || "dataLayer",
    additionalEvents: additionalEvents || {}
  });

  return (
    <div>
      <div>{gtm.noScriptAsReact()}</div>
      <div id={sId}>{gtm.scriptAsReact()}</div>
    </div>
  );
};
